import { memo, useMemo } from 'react';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { useTranslation } from 'react-i18next';
import { useNavigationHelper } from 'FrontRoyalAngular/useNavigationHelper';
import { Text } from 'Text';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';
import { BasicDesktopBox } from '../../BasicDesktopBox';

export function DigitalCertificateCheckBoxComponent({ userName }: { userName: string }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'digitalCertificateCheckBox' });
    const { loadRoute } = useNavigationHelper();

    const buttons = useMemo<ButtonConfig[]>(
        () => [
            {
                id: 'button_update_name',
                text: t('buttonUpdateName'),
                onPress: () => {
                    loadRoute('/settings/account');
                },
            },
        ],
        [t, loadRoute],
    );

    return <DigitalCertificateCheckBoxPresentation buttons={buttons} userName={userName} />;
}

export function DigitalCertificateCheckBoxPresentation({
    buttons,
    userName,
}: {
    buttons: ButtonConfig[];
    userName: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'digitalCertificateCheckBox' });
    return (
        <BasicDesktopBox boxKey={SidebarBoxKey.digital_certificate_check} headerText={t('heading')} buttons={buttons}>
            <Text as="div" weight="semibold" className="mb-3" uppercase>
                {userName}
            </Text>
            {t('content')}
        </BasicDesktopBox>
    );
}

export const DigitalCertificateCheckBox = memo(
    DigitalCertificateCheckBoxComponent,
) as typeof DigitalCertificateCheckBoxComponent;
